import ReactDOM from "react-dom/client";
import "./main.css";
import { App } from "./App/App";

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
